module.exports = __webpack_public_path__ + "static/media/Picture4.ad668805.png";